import { API, BACKEND_HOST, SITE_URL, updateAccessToken, NODE_ENV } from "./client";

export const API_USERS = `${BACKEND_HOST}/accounts/users`;
export const API_USERS_CRM = `${BACKEND_HOST}/accounts/users-crm`;
export const API_USERS_INQUIRY = `${BACKEND_HOST}/inquiry/articles`;
export const API_USER_CHANGE_PASSWORD = `${BACKEND_HOST}/accounts/set-user-password/`;
export const API_USER_CHANGE_PERMISSION = `${BACKEND_HOST}/accounts/set-user-permission/`;
export const API_USER_INFO = `${BACKEND_HOST}/accounts/user-info/`;
export const API_NOTIFICATION = `${BACKEND_HOST}/accounts/notification`;
export const API_COUPON = `${BACKEND_HOST}/coupon`;
export const API_VOUCHER = `${BACKEND_HOST}/voucher`;
export const API_SEND_TO_ALL_VOUCHER = `${API_VOUCHER}/send-to-all/`;
export const API_VOUCHERS = `${BACKEND_HOST}/accounts/vouchers`;
export const API_PACKAGE = `${BACKEND_HOST}/package`;
export const API_RESERVATIONS = `${BACKEND_HOST}/package/reservations`;
export const API_RESERVATIONS_CANCELED = `${BACKEND_HOST}/package/canceledreservations`;
export const API_RESERVATIONS_PREVIEW_CANCEL = `${BACKEND_HOST}/package/preview-cancel-reservation`;

export const API_RESERVATIONS_OPTIONS = `${BACKEND_HOST}/package/reservation-options`;
export const API_RESERVATIONS_OPTIONS_ALL = `${BACKEND_HOST}/package/reservation-options-all`;
export const API_RESERVATIONS_OPTIONS_TOTAL = `${BACKEND_HOST}/package/reservation-options-total`;

export const API_TICKETS = `${BACKEND_HOST}/ticket/items`;
export const API_TICKETS_REMOVE = `${BACKEND_HOST}/ticket/removal`;
export const API_TICKETS_CANCELED = `${BACKEND_HOST}/ticket/items-canceled`;
export const API_TICKETS_CHANGE = `${BACKEND_HOST}/ticket/change-ticket/`;

export const API_RESERVATIONS_CHANGE = `${BACKEND_HOST}/package/change-reservation/`;
export const API_RESERVATIONS_REMOVE = `${BACKEND_HOST}/package/remove-reservations/`;
export const API_RESERVATIONS_REMOVE_OPTIONS = `${BACKEND_HOST}/package/reservation-options`;

export const API_OPTIONS_LIST = `${BACKEND_HOST}/package/options`;

export const API_PACKAGE_OFFDAYS = `${BACKEND_HOST}/package/offdays`;

export const API_SITES_PERIODS = `${BACKEND_HOST}/sites/periods`;

export const API_SITES_USERVISIT = `${BACKEND_HOST}/sites/user-visit/`;
export const API_V2_CORE_METRIC_JOBS = `/api/v2/analytics/metric-jobs/`;

export const API_RESERVATION_ALL = `${BACKEND_HOST}/package/reservationAll`;
export const API_TICKET_ALL = `${BACKEND_HOST}/ticket/itemAll`;
export const API_VOUCHER_ALL = `${BACKEND_HOST}/accounts/voucherAll`;

// Orders (CRM)
export const API_ORDER_TOTAL_CRM = `${BACKEND_HOST}/package/user-order-total-crm/`;
export const API_ORDER_ERROR_HANDLINGS_CRM = `${BACKEND_HOST}/package/order-error-handlings-crm/`;
export const API_ORDER_ERROR_HANDLINGS_STATUS_CRM = `${BACKEND_HOST}/package/order-error-handlings-crm/status/`;
export const API_ORDER_ERROR_HANDLINGS_ACTIONS_CRM = `${BACKEND_HOST}/package/order-error-handlings-crm/actions/`;

export const API_RESERVATION_GIFTS = `${BACKEND_HOST}/package/reservation-gift`;
export const API_RESERVATION_GIFTS_REMOVE = `${BACKEND_HOST}/package/remove-reservation-gift/`;

export const API_USER_VOUCHER_GIFTS = `${BACKEND_HOST}/voucher/user-voucher-gift`;
export const API_USER_VOUCHER_GIFTS_REMOVE = `${BACKEND_HOST}/voucher/remove-user-voucher-gift/`;

export const API_TICKET_GIFTS = `${BACKEND_HOST}/ticket/ticket-gift`;

export const API_SALES_ADJUSTMENTS = `${BACKEND_HOST}/sales-adjustments/adjustment`;
export const API_SALES_ADJUSTMENTS_ENTITY = `${BACKEND_HOST}/sales-adjustments/entity`;
export const API_SALES_ADJUSTMENTS_MAIN_COST = `${BACKEND_HOST}/sales-adjustments/maincost`;
export const API_SALES_ADJUSTMENTS_MAIN_COST_TOTAL = `${BACKEND_HOST}/sales-adjustments/maincost-total`;

export const API_PRECOUPON = `${BACKEND_HOST}/precoupon`;
export const API_PRECOUPON_PRODUCT = `${BACKEND_HOST}/precoupon/precoupon`;
export const API_USER_PRECOUPON = `${BACKEND_HOST}/precoupon/user`;

export const API_SUPPLY_PRODUCT = `${BACKEND_HOST}/supply/product`;
export const API_SUPPLY_CART = `${BACKEND_HOST}/supply/product`;
export const API_SUPPLY_ITEM_LIST = `${BACKEND_HOST}/supply/item/`;
export const API_SUPPLY_ORDER_LIST = `${BACKEND_HOST}/supply/order-list/`;
export const API_SUPPLY_ITEM_LIST_ADMIN = `${BACKEND_HOST}/supply/item?view_mode=admin`;

export const API_SHOPPING_PRODUCT = `${BACKEND_HOST}/shop/product`;
export const API_SHOPPING_CART = `${BACKEND_HOST}/shop/product`;
export const API_SHOPPING_ITEM_LIST = `${BACKEND_HOST}/shop/item/`;
export const API_SHOPPING_ORDER_LIST = `${BACKEND_HOST}/shop/order-list/`;

export function getCookie(name: string): string | null {
  if (document.cookie) {
    try {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(name))
        ?.split("=")[1];
      return cookieValue || null;
    } catch (error) {
      return null;
    }
  } else {
    return null;
  }
}

export function resetToken(): void {
  // function delete_cookie( name, path, domain ) {
  const name = "access_token";
  const path = "/";
  const domain = document.domain;
  if (getCookie(name)) {
    document.cookie = name + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

export async function getDataFromUrl(url: string, signal: AbortSignal | null = null): Promise<any> {
  const response = await API.get(url, { signal });
  return response.data;
}

export async function getCancelDay(cancelDate: string): Promise<any> {
  const response = await API.get(`/sites/cancel-days/?date=${cancelDate}`);
  return response.data;
}

export async function postCancelDay(
  cancelDate: string, 
  reason: string, 
  buttonName?: string, 
  title?: string, 
  description?: string
): Promise<any> {
  const body: any = {
    date: cancelDate,
    reason: reason,
  };
  if (buttonName) body.buttonname = buttonName;
  if (title) body.title = title;
  if (description) body.description = description;

  const response = await API.post('/sites/cancel-days/', body);
  return response.data;
}

export async function deleteCancelDayById(id: number): Promise<any> {
  const response = await API.delete(`/sites/cancel-days/${id}/`);
  return response.data;
}

export async function postData(url: string, body: any, method: string = "POST"): Promise<any> {
  const response = await API({
    method: method as any,
    url,
    data: body
  });
  return response.data;
}

export async function postDataWithFile(url: string, formData: FormData, method: string = "POST"): Promise<any> {
  const response = await API({
    method: method as any,
    url,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export async function getUserList() {
  const response = await API.get(`/accounts/users/`);
  return response.data;
}

export type CoreMetricJobStatus = "queued" | "running" | "success" | "failed";

export interface CoreMetricJob {
  id: number;
  status: CoreMetricJobStatus;
  start_date: string;
  end_date: string;
  requested_at: string;
  started_at?: string | null;
  finished_at?: string | null;
  progress_message?: string | null;
  error_message?: string | null;
}

export interface CoreMetricSummary {
  period_start: string;
  period_end: string;
  dau_latest: number;
  wau_latest: number;
  mau_latest: number;
  cvr: number;
  visitors: number;
  converters: number;
}

export interface CoreMetricSeriesPoint {
  date: string;
  dau: number;
  converters: number;
}

export interface CoreMetricJobResult {
  id: number;
  status: CoreMetricJobStatus;
  summary: CoreMetricSummary;
  series: CoreMetricSeriesPoint[];
  finished_at?: string | null;
}

export async function getCoreMetricJobs(): Promise<CoreMetricJob[]> {
  const response = await API.get(API_V2_CORE_METRIC_JOBS);
  return response.data;
}

export async function createCoreMetricJob(body: {
  start_date: string;
  end_date: string;
  force_refresh?: boolean;
}): Promise<CoreMetricJob> {
  const response = await API.post(API_V2_CORE_METRIC_JOBS, body);
  return response.data;
}

export async function getCoreMetricJob(jobId: number): Promise<CoreMetricJob> {
  const response = await API.get(`${API_V2_CORE_METRIC_JOBS}${jobId}/`);
  return response.data;
}

export async function getCoreMetricJobResult(jobId: number): Promise<CoreMetricJobResult> {
  const response = await API.get(`${API_V2_CORE_METRIC_JOBS}${jobId}/result/`);
  return response.data;
}

export async function getUserInfo() {
  const response = await API.get(`${API_USER_INFO}`);
  return response.data;
}

export async function getCouponData() {
  const response = await API.get(`${API_COUPON}/`);
  return response.data;
}

export async function getVoucherData() {
  const response = await API.get(`${API_VOUCHER}/?include_retired=true`);
  return response.data;
}

export async function deleteVoucherItem(recordId) {
  const response = await API.delete(`${API_VOUCHER}/removal/${recordId}/`);
  return response.data;
}

export async function changeVoucherItem(recordId) {
  const response = await API.put(`${API_VOUCHER}/state-change/${recordId}/`);
  return response.data;
}

export async function cancelVoucherItem(recordId) {
  const response = await API.put(`${API_VOUCHER}/state-change-cancel/${recordId}/`);
  return response.data;
}

export async function changeReservationState(recordId, _state) {
  const response = await API.put(`${API_RESERVATIONS_CHANGE}`, {
    id: recordId,
    reservation: _state
  });
  return response.data;
}

export async function deleteReservationItem(recordId, cancelAmtount = 0) {
  const response = await API.delete(`${API_RESERVATIONS_REMOVE}${recordId}/?amount=${cancelAmtount}`);
  return response.data;
}

export async function refundReservationItem(recordId, cancelAmtount = 0, cancelReason = "관리자취소") {
  const response = await API.post(`${BACKEND_HOST}/package/cancel-reservation/`, {
    id: recordId,
    silent: true,
    cancel_amount: cancelAmtount,
    cancel_reason: cancelReason || "관리자취소",
  });
  return response.data;
}

export async function refundOrderTotal(recordId, cancelAmount = 0, cancelReason = "관리자취소", filterSite = "", cancelLinkedItems = true) {
  const response = await API.post(`${BACKEND_HOST}/package/cancel-order-total-crm/`, {
    id: recordId,
    cancel_amount: cancelAmount,
    cancel_reason: cancelReason || "관리자취소",
    filter_site: filterSite,
    cancel_linked_items: cancelLinkedItems,
  });
  return response.data;
}

export async function getOrderPgBalance(recordId, filterSite = "") {
  const response = await API.get(`${BACKEND_HOST}/package/order-pg-balance-crm/`, {
    params: {
      id: recordId,
      filter_site: filterSite,
    },
  });
  return response.data;
}

export async function addReservationItem(dataBody) {
  const response = await API.post(`${BACKEND_HOST}/package/add-reservation-crm/`, {
    phone_num: dataBody.phoneNum,
    spot_id: dataBody.spot.id,
    resv_date: dataBody.reservDate,
    notify_user: dataBody.notifyUser,
    paid_amount: dataBody.paidAmount,
    customer_display_name: dataBody.customerDisplayName ?? "",
  });
  return response.data;
}

interface ChangeReservationParams {
  reserv_state?: string;
  start_date?: string;
  paid_amount?: number;
  spot_id?: number;
  phone_num?: string;
  customer_display_name?: string;
}

export async function changeReservationItem(
  recordId: string | number,
  params: ChangeReservationParams
) {
  const data: Partial<ChangeReservationParams> = {};
  if (params.reserv_state) data.reserv_state = params.reserv_state;
  if (params.start_date) data.start_date = params.start_date;
  if (params.paid_amount) data.paid_amount = params.paid_amount;
  if (params.spot_id) data.spot_id = params.spot_id;
  if (params.phone_num) data.phone_num = params.phone_num;
  if (Object.prototype.hasOwnProperty.call(params, "customer_display_name")) data.customer_display_name = params.customer_display_name;

  const response = await API.put(`${BACKEND_HOST}/package/change-reservation-admin/${recordId}/`, data);
  return response.data;
}

export type PackageOperationalSeat = {
  id: number;
  package: number;
  package_name: string;
  name: string;
  display_order: number;
  is_active: boolean;
};

export async function getPackageOperationalSeats(packageId: string | number, params: Record<string, any> = {}) {
  const response = await API.get(`/api/v2/package-operational-seats/`, {
    params: { package: packageId, ...params },
  });
  return response.data;
}

export async function createPackageOperationalSeat(data: {
  package: string | number;
  name: string;
  display_order?: number;
  is_active?: boolean;
}) {
  const response = await API.post(`/api/v2/package-operational-seats/`, data);
  return response.data;
}

export async function updatePackageOperationalSeat(
  seatId: string | number,
  data: Partial<Pick<PackageOperationalSeat, "name" | "display_order" | "is_active">>
) {
  const response = await API.patch(`/api/v2/package-operational-seats/${seatId}/`, data);
  return response.data;
}

export async function deletePackageOperationalSeat(seatId: string | number) {
  const response = await API.delete(`/api/v2/package-operational-seats/${seatId}/`);
  return response.data;
}

export async function assignReservationOperationalSeat(recordId: string | number, seatId: string | number) {
  const response = await API.put(`/api/v2/reservations/${recordId}/operational-seat-assignment/`, {
    seat: seatId,
  });
  return response.data;
}

export async function clearReservationOperationalSeat(recordId: string | number) {
  const response = await API.delete(`/api/v2/reservations/${recordId}/operational-seat-assignment/`);
  return response.data;
}

export async function deleteReservationOption(recordId) {
  const response = await API.delete(`${API_RESERVATIONS_REMOVE_OPTIONS}/${recordId}/`);
  return response.data;
}

export async function deleteReservationOptionItem(recordId, cancelAmtount = 0) {
  const response = await API.delete(`${API_RESERVATIONS_REMOVE_OPTIONS}/${recordId}/?amount=${cancelAmtount}`);
  return response.data;
}

export async function deleteTicketItem(recordId) {
  const response = await API.delete(`${API_TICKETS_REMOVE}/${recordId}/`);
  return response.data;
}

export async function refundTicketItem(recordId, cancelReason = "관리자취소") {
  const response = await API.post(`${BACKEND_HOST}/ticket/cancel-ticket-crm/`, {
    id: recordId,
    cancel_reason: cancelReason || "관리자취소",
  });
  return response.data;
}

export async function changeTicket(recordId, _state) {
  const response = await API.put(`${API_TICKETS_CHANGE}`, {
    id: recordId,
    ticket: _state,
  });
  return response.data;
}

export async function createOffDay(packageId, _date, _dayoff = true) {
  const response = await API.post(`${API_PACKAGE_OFFDAYS}/`, {
    package: packageId,
    date: _date,
    dayoff: _dayoff,
  });
  return response.data;
}

export async function changeOffDay(offdayId, packageId, _date, _dayoff = true) {
  const response = await API.put(`${API_PACKAGE_OFFDAYS}/${offdayId}/`, {
    package: packageId,
    date: _date,
    dayoff: _dayoff,
  });
  return response.data;
}

export async function deleteReservationGiftItem(recordId) {
  const response = await API.delete(`${API_RESERVATION_GIFTS_REMOVE}${recordId}/`);
  return response.data;
}

export async function changeUserDetail(recordId, values) {
  const response = await API.put(`${API_USERS_CRM}/${recordId}/`, {
    phone_num: values.phone_num,
    username: values.username,
    business_name: values.business_name,
  });
  return response.data;
}

export async function changeUserPassword(phoneNum, password) {
  const response = await API.post(`${API_USER_CHANGE_PASSWORD}`, {
    phone_num: phoneNum,
    password: password,
  });
  return response.data;
}

export async function changeUserPermission(phoneNum, superuser, staff) {
  const response = await API.post(`${API_USER_CHANGE_PERMISSION}`, {
    phone_num: phoneNum,
    superuser: !!superuser,
    staff: !!staff,
  });
  return response.data;
}

export async function deleteUserVoucherGiftItem(recordId) {
  const response = await API.delete(`${API_USER_VOUCHER_GIFTS_REMOVE}${recordId}/`);
  return response.data;
}

export async function changeTicketState(recordId, _state) {
  const response = await API.put(`${API_TICKET_GIFTS}/${recordId}/`, {
    state: _state,
  });
  return response.data;
}

export async function deleteTicketGiftItem(recordId) {
  const response = await API.delete(`${API_TICKET_GIFTS}/${recordId}/`);
  return response.data;
}

// Export messaging service
export { MessagingService, messagingService } from "./services/messaging.service";

export { API, updateAccessToken, SITE_URL, BACKEND_HOST, NODE_ENV };
